export default __webpack_public_path__ + "static/media/audisoft4.52e4bd8c.mov";